import { Route, Routes } from "react-router-dom";
import Quotamat from "../quotamat/quotamat";

const Quatomator_rou = () => {
    return <>
    <Quotamat/>
    </>
    
}
export default Quatomator_rou;